import {UserService} from '@/api/user';
import {CustomComponentContext, CustomComponentContextType} from '@/utils/contexts/CustomComponentContext';
import {Input} from 'alurkerja-ui';
import {useContext, useEffect} from 'react';
import {Controller} from "react-hook-form";
import { useFetch } from '@/hooks/useFetch'

type CompanyData = {
  id: number;
  name: string;
}

// eslint-disable-next-line react-refresh/only-export-components
export const specDepartmentName = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Department',
    name: 'department',
    type: 'text',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Company',
    name: 'company_requestor',
    type: 'text',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Company',
    name: 'company_requestor',
    type: 'text',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Company',
    name: 'company_id_requestor',
    type: 'Integer',
  },
];

export default function DepartmentName() {
  const { setValue, taskData, control } = useContext<CustomComponentContextType>(CustomComponentContext);
  const { data: userData } = UserService.useGetProfile();

  const {
    data: companyData,
  } = useFetch<CompanyData[]>({
    path: '/api/v1/odoo/company',
  })

  const classNamesLabel = "after:text-sm font-medium";

  useEffect(() => {
    if (userData) {
      setValue('department', userData.department);
      setValue('company_requestor', userData.company);
    }
  }, [userData, setValue]);

  useEffect(() => {
    if (companyData && userData) {
      // find the company name based on the userData.company
      const company = companyData.find(c => c.name === userData.company);

      setValue('company_id_requestor', company?.id ?? null);
    }
  }, [companyData, userData])

  return (
    <div className="grid grid-cols-2 space-x-2">
      <div>
        <label htmlFor="department" className={classNamesLabel}>
          Department
        </label>
        <Controller
          name={'department'}
          control={control}
          render={({ fieldState }) => {
            return (
              <>
                <Input
                  value={userData?.department ?? ''}
                  defaultValue={taskData?.variables?.department ?? null}
                  disabled
                />
                {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
              </>
            );
          }}
        ></Controller>
      </div>
    </div>
  );
}

